// src/utils/headers.js
export const getAuthHeaders = (apiKey, authUser) => {
  const token =
    typeof authUser?.token === 'string'
      ? authUser.token
      : authUser?.token?.access_token || '';

  const headers = {
    'Content-Type': 'application/json'
  };

  // Add Bearer token if available
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};
